import { ReactComponent as CenterDotIcon } from "assets/CenterDotIcon2.svg";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

export const useWorkflowChipStyles = makeThemedStyles(
  "WorkflowTypeChip",
  (theme) => ({
    root: {
      fontSize: "12px",
      lineHeight: "1.25em",
      height: "30px",
      padding: "0.37em 1.33em",
      color: "white",
      margin: "10px 0 14px 0",
      gap: "2px",
      borderRadius: "1.1em",
      borderColor: "red !important",
      top: "0.833em",
      right: "50%",
      display: "flex",
      flexWrap: "nowrap",
      width: "100%",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      background: "rgb(14, 156, 240)",
      "& svg": {
        width: "8px",
        height: "8px",
        marginLeft: "3px",
        marginRight: "3px",
      },
    },
  })
);

const WorkflowTypeChip = (
  props: React.PropsWithChildren<{
    elementType: string;
    workflowType: string;
  }>
) => {
  const classes = useWorkflowChipStyles();
  return (
    <>
      <div className={classes.root}>
        {props.elementType}
        <CenterDotIcon />
        {props.workflowType}
      </div>
    </>
  );
};

export default WorkflowTypeChip;
